import { OPTIONS } from "~/pages/Editor/options";

export const addGMTOffsetToDate = (dateString: string = null) => {
  if (!dateString) {
    return "";
  }
  let date = new Date(dateString);
  let timezoneOffset = date.getTimezoneOffset();
  let gmtOffsetInHours = timezoneOffset / 60;
  date.setHours(23 - gmtOffsetInHours, 59, 0, 0);

  return date;
};
export const filteredOptions = ({ hasPermission }) => {
  return OPTIONS.filter((item) => {
    if (item.permissions) {
      if (typeof item.permissions === "string") {
        return hasPermission(item.permissions);
      }
      if (Array.isArray(item.permissions)) {
        return item.permissions.some((perm) => hasPermission(perm));
      }
    }

    return false;
  });
};
